import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Logo } from "../constant/Index";
import { profile_img } from "../constant/Index";
import { logout } from "../store/reducers/AuthReducers";

const Header = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { user } = useSelector((state) => state.AuthReducer);
	const [view, setView] = useState(false);
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	const HandleLogout = () => {
		dispatch(logout());
		navigate("/");
	};
	let currentUrl = window.location.href.split("/");
	let [responsive, setResponsive] = useState(false);
	return (
		<>
			<div id="headerTop">
				<div className="container">
					<div className="row align-items-center">
						<div className="col-lg-3">
							<div className="logoBox">
								<Link to="/">
									<figure>
										<img src={Logo} alt="" className="img-fluid" />
									</figure>
								</Link>
							</div>
						</div>
						<div className="col-lg-9">
							<div className="navbar-menu">
								<ul className="menus">
									<li
										className={`${
											currentUrl?.[3] === "" ? "active menu-item" : "menu-item"
										}`}
									>
										{/* <a href="#" className="menu-link active">
											Home
										</a> */}
										<Link to="/">Home</Link>
									</li>
									<li
										className={`${
											currentUrl?.[3] === "about"
												? "active menu-item"
												: "menu-item"
										}`}
									>
										{/* <a href="#" className="menu-link">
											About Us
										</a> */}
										<Link to="/about">About Us</Link>
									</li>
									<li
										className={`${
											currentUrl?.[3] === "products"
												? "active menu-item"
												: "menu-item"
										}`}
									>
										{/* <a href="#" className="menu-link">
											Products
										</a> */}
										<Link to="/products">Products</Link>
									</li>
									<li
										className={`${
											currentUrl?.[3] === "services"
												? "active menu-item"
												: "menu-item"
										}`}
									>
										{/* <a href="#" className="menu-link">
											Services
										</a> */}
										<Link to="/services">Services</Link>
									</li>
									{/* <li className="menu-item">
										<a href="/contact" className="menu-link">
											Contact Us
										</a>
									</li> */}
									<li
										className={`${
											currentUrl?.[3] === "contact"
												? "active menu-item"
												: "menu-item"
										}`}
									>
										{/* <a href="#" className="menu-link">
											Contact Us
										</a> */}
										<Link to="/contact">Contact Us</Link>
									</li>

									{user ? (
										<>
											<button
												onClick={() => navigate("/account")}
												style={{
													border: "none",
													cursor: "pointer",
													fontSize: "20px",
													outline: "none",
												}}
											>
												<i className="fa fa-user" aria-hidden="true"></i>
											</button>

											<li className="menu-item button">
												<button className="signin" onClick={HandleLogout}>
													Logout
												</button>
											</li>
										</>
									) : (
										<li className="menu-item button">
											<Link to="/login" className="signin">
												Sign In
											</Link>
										</li>
									)}

									<li className="menu-item button">
										<Link to="/applyforloans">Apply Loan</Link>
									</li>
									<li className="menu-item d-none">
										<Link to="/login" className="signin">
											<img src={profile_img} />
										</Link>
									</li>
								</ul>
								<div className="open_navbar" onClick ={ () =>setResponsive(true)}>
									<i className="fa fa-bars"></i>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className={responsive ? "mobile_header show" : "mobile_header"}>
				<div className="cancel" onClick={() => setResponsive(false)}>
					<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#000" className="bi bi-x" viewBox="0 0 16 16">
						<path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
					</svg>
				</div>
				<ul className="mobile_menus">
					<li className="menu_items"><Link className="menu_links active_menu" to="/">Home</Link></li>
					<li className="menu_items"><Link className="menu_links" to="/about">About Us</Link></li>
					<li className="menu_items"><Link className="menu_links" to="/products">Products</Link></li>
					<li className="menu_items"><Link className="menu_links" to="/services">Services</Link></li>
					<li className="menu_items"><Link className="menu_links" to="/contact">Contact</Link></li>
					{user ? (
						<>
							<li className="menu_items"><Link className="menu_links" to="/account">
								<i className="fa fa-user pr-2" aria-hidden="true"></i> My Account</Link></li>
							<li className="menu_items"><a className="menu_links signin" role="button" onClick={HandleLogout}>
								Logout
							</a></li>
						</>
						
					) : (
						<li className="menu_items"><Link className="menu_links" to="/login">Sign In</Link></li>
					)}
					<li className="menu_items"><Link className="menu_links" to="/applyforloans">Apply Loan</Link></li>
				</ul>
			</div>
		</>
	);
};

export default Header;
